import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/es";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const SensorStatisticsTable = ({ statistics }) => {
  if (!statistics.length || !statistics.some((item) => item != null)) {
    return null;
  }

  return (
    <Box my={4}>
      <Typography variant="h6" gutterBottom>
        Estadísticas por sensor
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#1976d2" }}>
              <TableCell sx={{ color: "white" }}>Equipo</TableCell>
              <TableCell sx={{ color: "white" }}>Sensor</TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Promedio
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Mínimo
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Máximo
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Desviación estándar
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Muestras
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Primera fecha
              </TableCell>
              <TableCell sx={{ color: "white" }} align="right">
                Última fecha
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {statistics.map((stat) => (
              <TableRow key={`${stat.table}-${stat.sensorName}`}>
                <TableCell component="th" scope="row">
                  {stat.DeviceName}
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 160,
                  }}
                >
                  {stat.SensorName}
                </TableCell>
                <TableCell align="right">
                  {stat.Average.toFixed(1) + "°C"}
                </TableCell>
                <TableCell align="right">
                  {stat.Minimun.toFixed(1) + "°C"}
                </TableCell>
                <TableCell align="right">
                  {stat.Maximun.toFixed(1) + "°C"}
                </TableCell>
                <TableCell align="right">
                  {stat.StandardDeviation.toFixed(1) + "°C"}
                </TableCell>
                <TableCell align="right">{stat.Samples}</TableCell>
                <TableCell align="right">
                  {dayjs.utc(stat.FirstDate).format("DD/MM/YYYY ")}
                </TableCell>
                <TableCell align="right">
                  {dayjs.utc(stat.LastDate).format("DD/MM/YYYY ")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SensorStatisticsTable;
